import React from "react";
import PropTypes from "prop-types";
import { GroupRounded } from "@mui/icons-material";
import { styled as materialStyled } from "@mui/styles";

import { LinkBlock } from "commons";
import { convertToMoney } from "commons/src/Money";

import { AccountLink, CaretIcon, PlainList, Highlight, Value, Detail } from "./components";
import { routes } from "../../helpers/RouteHelpers";

export function AccountBlock({ value, isJoint, accountNumber, name, status, alias }) {
    const convertedValue = value || value === 0 ? <span>{convertToMoney(value)}</span> : null;

    const nameIcon = isJoint ? (
        <JointAccIcon color="primary" data-testid="joint-account-icon" />
    ) : null;

    return (
        <AccountLink
            to={routes.client.folioDetails({ accountNum: accountNumber })}
            data-testid="account-link"
        >
            <LinkBlock>
                <PlainList>
                    <Highlight data-testid="account-block-account-type">
                        {name} {nameIcon}
                    </Highlight>
                    {alias ? (
                        <Detail data-testid="account-block-account-alias">{alias}</Detail>
                    ) : null}
                    <Detail data-testid="account-block-account-number">{accountNumber}</Detail>
                    <Detail data-testid="account-block-account-status">{status}</Detail>
                </PlainList>
                <div>
                    <Value data-testid="account-block-value">{convertedValue}</Value>
                    <CaretIcon />
                </div>
            </LinkBlock>
        </AccountLink>
    );
}

const JointAccIcon = materialStyled(GroupRounded)({
    marginLeft: "0.5rem "
});

AccountBlock.propTypes = {
    name: PropTypes.string,
    accountNumber: PropTypes.string,
    status: PropTypes.string,
    value: PropTypes.number,
    isJoint: PropTypes.bool,
    alias: PropTypes.string
};
